// extracted by mini-css-extract-plugin
export var dropdownButton = "_4g-0";
export var fullWidthDropdownButton = "_4g-1";
export var iconPlaceholder = "_4g-2";